import { axiosBasic } from "../../../api/axios";
import { config } from "../../../api/endPoints";
import { Common } from "../../../utils";
import { GET_ALL_USER_BOOKMARKS, IS_LOADING } from "./userBookmarksActionsTypes"; 

const { UserBookmarks } = config.REST_API;
const {ROOT_URL_Version_1}=config;
export const isLoading = (value) => ({
  type: IS_LOADING,
  payload: value
});

export const userAllBookmarks = (data)=>({
    type: GET_ALL_USER_BOOKMARKS,
    payload: data
});

export const onGetUserAllBookmarks = () => dispatch => {
  dispatch(isLoading(true));
  axiosBasic
    .get(ROOT_URL_Version_1+UserBookmarks.GetUserAllBookmarks)
    .then(response => {
      const { success, data, message } = response.data;
      if (success) {
        dispatch(userAllBookmarks(data.UserBookmarks));
      } else {
        Common.showErrorMessage(message);
      }
    })
    .catch(error => {
      Common.showErrorMessage(error);
    }).finally(()=>{
      dispatch(isLoading(false));
    });
};